module.exports = __webpack_public_path__ + "img/SeafarersHeroesOfPandemic2_7-9-2021.29c5790f.jpg";